// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a0ce7a2a","453":"9b264095","732":"13c4fb18","977":"5fd11290"}[chunkId] + ".chunk.js";
};